import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button
} from 'semantic-ui-react';

const AssignSerialForm = ({
  serial,
  dirty,
  onSubmit,
  onChange,
  onCancel
}) => (
  <Form size='tiny' onSubmit={onSubmit}>
    <Form.Group>
      <Form.Select
        width={ 16 }
        label='License Type'
        options={ [{ text: "License", value: 'license' }, { text: "License Pool", value: 'license_pool' }] }
        name='type'
        value={ serial.type }
        onChange={ onChange }
      />
    </Form.Group>
    <Form.Group>
      {
        serial.type === 'license' ? (
          <Form.Input
            width={ 16 }
            label='License ID'
            name='license_id'
            placeholder='License ID'
            value={ serial.license_id }
            onChange={ onChange }
          />
        ) : null
      }
      {
        serial.type === 'license_pool' ? (
          <Form.Input
            width={ 16 }
            label='License Pool ID'
            name='license_pool_id'
            placeholder='License Pool ID'
            value={ serial.license_pool_id }
            onChange={ onChange }
          />
        ) : null
      }
    </Form.Group>
    <Button.Group>
      <Button onClick={onCancel}>Cancel</Button>
      <Button.Or />
      <Button positive={dirty} disabled={!dirty} type="submit">Save</Button>
    </Button.Group>
  </Form>
)

AssignSerialForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  serial: PropTypes.object.isRequired,
  dirty: PropTypes.bool.isRequired
}

export default AssignSerialForm



// WEBPACK FOOTER //
// ./webAdmin/forms/serialAssign.js